<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              OSPF Neighbor Information
              <!-- <router-link
                v-if="!actionCreate"
                :to="{ name: 'NotificationSettingAdd' }"
                class="btn ml-auto"
              >
                <i class="icon-plus"></i> New
              </router-link> -->
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">OSPF Neighbor Information</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div
            class="card-header"
            v-if="!_.isEmpty(this.pre.ospfNeighborList) || is_loading == false"
          >
            <div class="btn-toolbar pull-right">
              <el-dropdown
                split-button
                :trigger="'click'"
                @command="handleSelectedRows"
                type="primary"
                v-if="this.selected_row.length"
                class="mr-1"
              >
                {{ this.selected_row.length }}
                {{ "item" | pluralize(this.selected_row.length) }} selected
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="delete"
                    >Delete Selected Items</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <button
                class="btn btn-info d-none"
                type="button"
                @click="showFilter = !showFilter"
              >
                <i class="fa fa-filter"></i> Filter
              </button>
            </div>
            <!-- 
            <div class="card-tools">
              <button class="btn btn-outline" @click="exportFile()">
                <i class="icon-download"></i> Export
              </button>
            </div> -->
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row"></div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9">
                      <button type="submit" class="btn btn-common m-2px">
                        <i class="fas fa-search"></i> Search
                      </button>
                      <button type="reset" class="btn btn-warning" @click="resetFilter()">
                        <i class="fas fa-undo"></i> Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="card-body pb-1">
            <div v-if="!_.isEmpty(this.pre.ospfNeighborList) && is_loading == false">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h6>Total Item: {{ this.pre.ospfNeighborList.length }}</h6>
              </div>
              <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Instance</th>
                      <th>Neighbor ID</th>
                      <th>Neighbor Address</th>
                      <th>Interface Address</th>
                      <th>State</th>
                      <th>Priority</th>
                    </tr>
                  </thead>
                  <tbody class="list">
                    <tr v-for="(neighbor, index) in displayedNeighbors" :key="index">
                      <td>{{ neighbor.Instance }}</td>
                      <td>{{ neighbor.NeighborID }}</td>
                      <td>{{ neighbor.NeighborAddress }}</td>
                      <td>{{ neighbor.InterfaceAddress }}</td>
                      <td>{{ neighbor.State }}</td>
                      <td>{{ neighbor.Priority }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 text-right d-block d-sm-none">
                Swipe <i class="icon-swipe"></i>
              </div>
            </div>
            <div
              class="p-4"
              v-if="_.isEmpty(this.pre.ospfNeighborList) && is_loading == false"
            >
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>
          <div
            class="pagination card-footer pb-3"
            v-if="!_.isEmpty(this.pre.ospfNeighborList) && is_loading == false"
          >
            <div class="el-pagination is-background">
              <button
                class="pagination-btn btn-prev"
                @click="setPage(currentPage - 1)"
                :disabled="currentPage === 1"
              >
                <i class="el-icon el-icon-arrow-left"></i>
              </button>
              <ul class="el-pager">
                <li
                  v-for="page in totalPages"
                  :key="page"
                  class="pagination-page"
                  :class="{ active: page === currentPage }"
                  @click="setPage(page)"
                >
                  {{ page }}
                </li>
              </ul>
              <button
                class="pagination-btn btn-next"
                @click="setPage(currentPage + 1)"
                :disabled="currentPage === totalPages"
              >
                <i class="el-icon el-icon-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapGetters } from "vuex";
const fileDownload = require("js-file-download");

export default {
  name: "OSPF Neighbor Informations",
  metaInfo: {
    title: "OSPF Neighbor Informations | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },
  data: () => ({
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    connection: false,
    isfound: 0,
    routeInfo: {},
    actionCreate: false,
    actionView: true,
    actionEdit: true,
    actionDelete: false,
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: {
      ospfNeighborList: [],
    },
    currentPage: 1,
    perPage: 2,
    is_loading: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
    selected_row: [],
    is_selected_all: false,
  }),

  computed: {
    ...mapGetters(["profile"]),
    displayedNeighbors() {
      const startIndex = (this.currentPage - 1) * this.perPage;
      const endIndex = Math.min(
        startIndex + this.perPage,
        this.pre.ospfNeighborList.length
      );
      return this.pre.ospfNeighborList.slice(startIndex, endIndex);
    },
    totalPages() {
      return Math.ceil(this.pre.ospfNeighborList.length / this.perPage);
    },
  },
  async mounted() {
    await this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      // await CommonAPI.getCustomPermission(
      //   "/get-custom-permission-infos?path=api/notification_settings"
      // ).then((response) => {
      //   if (response.status == 200) {
      //     this.custom_permission_data = response.data;
      //   }
      // });

      // if (!_.isEmpty(this.custom_permission_data)) {
      //   this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
      //     this.custom_permission_data.action_permission,
      //     this.custom_permission_data["create_id_condition"],
      //     this.user_detail,
      //     this.custom_permission_data.enableAdministratorPermissionByDefault
      //   );
      // }

      this.getOSPFNeighborList();
    },

    async getFilterData() {
      this.is_loading = true;
      this.is_loading = false;
    },
    reload: function () {},

    formatDuration(duration) {
      return duration === null
        ? "N/A"
        : duration / 3600 > 1
        ? duration / 3600 + " hours"
        : duration / 3600 + " hour";
    },
    getOSPFNeighborList: function () {
      const loadingElement = document.getElementById("loading");
      this.is_loading = true;
      axios
        .post("/add-change-log", {
          syncprocess: "routing_info_sync",
          command: "sh ip ospf neighbor json",
          accountId: LocalStorage.get("accountId"),
        })
        .then((response) => {
          if (response.data === "ok") {
            this.countConnectionCheck = 0;
            this.isfound = 0;
            this.routeInfo = {};

            this.connection = setInterval(() => {
              // console.log('Calling loadRouteInfo')
              this.loadRouteInfo();
            }, 1000);
          } else {
            this.is_loading = false;
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          this.is_loading = false;
        });
    },

    loadRouteInfo() {
      axios
        .post("/load-route-info", {
          accountId: LocalStorage.get("accountId"),
        })
        .then((response) => {
          if (response.data === "not ok" || !response.data) {
            this.isfound = 0;
          } else {
            this.routeInfo = response.data;
            this.isfound = 1;
            clearInterval(this.connection);
            this.parseResponse();
          }
        })
        .catch((error) => {
          console.error("Error loading route info:", error);
        })
        .finally(() => {
          this.countConnectionCheck++;
          if (this.countConnectionCheck >= 15 || this.isfound === 1) {
            clearInterval(this.connection);
            if (this.isfound === 1) {
              this.parseResponse();
            }
            this.is_loading = false;
          }
        });
    },

    parseResponse() {
      const routeinfoJson = this.routeInfo;
      let neighborObj = routeinfoJson.data;
      const lstUpdate = routeinfoJson.lastUpdate;

      neighborObj = JSON.parse(neighborObj);
      neighborObj = neighborObj.neighbors;

      if (neighborObj) {
        this.pre.ospfNeighborList = [];
        Object.keys(neighborObj).forEach((key) => {
          neighborObj[key].forEach((element) => {
            const obj = {};
            obj.Instance = "NA";
            obj.NeighborID = key;
            obj.NeighborAddress = element.address;
            obj.InterfaceAddress = element.ifaceName;
            obj.State = element.state;
            obj.Priority = element.priority;
            this.pre.ospfNeighborList.push(obj);
          });
        });
      }
    },

    setPage(pageNumber) {
      if (pageNumber >= 1 && pageNumber <= this.totalPages) {
        this.currentPage = pageNumber;
      }
    },
  },
  created() {
    // this.$emit('update:layout', MasterLayout)
    // this.parseResponse()
  },
};
</script>

<style>
.pagination {
  display: flex;
  justify-content: right;
  align-items: right;
  margin-top: 20px;
}

.pagination-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.pagination-info {
  display: inline-block;
  margin: 0 12px;
  color: #333;
  font-size: 14px;
}

.pagination-btn {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 15px;
  margin: 0 5px;
  cursor: pointer;
  background: #00a79c;
}

.pagination-btn.prev {
  color: #333;
  border: 1px solid #ccc;
  padding: 3px 8px;
  margin: 0 2px;
  cursor: pointer;
  font-size: 12px;
  height: 20px;
  line-height: 1.2;
  margin-right: 10px;
}

.pagination-btn.next {
  color: #333;
  border: 1px solid #ccc;
  padding: 3px 8px;
  margin: 0 2px;
  cursor: pointer;
  font-size: 12px;
  height: 20px;
  line-height: 1.2;
  margin-left: 10px;
}
.pagination-pages {
  display: flex;
}

.pagination-page {
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ccc;
  padding: 3px 8px;
  margin: 0 2px;
  cursor: pointer;
  font-size: 12px;
  height: 20px;
  line-height: 1.2;
}

.pagination-page.active {
  background-color: #00a79c;
  color: white;
}
</style>
